interface HexLatticeProps {
  className?: string;
}

const RADIUS = 28;
const COLS = 12;
const ROWS = 16;
const DX = RADIUS * Math.sqrt(3);
const DY = RADIUS * 1.5;

function hexPoints(cx: number, cy: number): string {
  const points: string[] = [];
  for (let k = 0; k < 6; k++) {
    const angle = ((60 * k - 90) * Math.PI) / 180;
    const x = cx + RADIUS * Math.cos(angle);
    const y = cy + RADIUS * Math.sin(angle);
    points.push(`${x.toFixed(1)},${y.toFixed(1)}`);
  }
  return points.join(' ');
}

const cells = Array.from({ length: ROWS }, (_, row) =>
  Array.from({ length: COLS }, (_, col) => {
    const cx = col * DX + (row % 2 === 1 ? DX / 2 : 0);
    const cy = row * DY;
    const seed = row * 7 + col * 13;
    return { row, col, cx, cy, lit: seed % 23 === 0, delay: (seed % 11) * 0.45 };
  }),
).flat();

const viewW = COLS * DX + DX;
const viewH = ROWS * DY + RADIUS * 2;

/** Fondo decorativo: retícula hexagonal que respira lentamente, con celdas "encendidas". */
export default function HexLattice({ className = '' }: HexLatticeProps) {
  return (
    <svg
      className={`hx-lattice ${className}`}
      viewBox={`0 0 ${viewW} ${viewH}`}
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
    >
      {cells.map(({ row, col, cx, cy, lit, delay }) => (
        <polygon
          key={`${row}-${col}`}
          points={hexPoints(cx, cy)}
          fill={lit ? 'var(--color-hx-amber)' : 'none'}
          fillOpacity={lit ? 0.5 : 0}
          stroke="var(--color-hx-line)"
          strokeWidth={1}
          className={lit ? 'hx-lit' : undefined}
          style={lit ? { animationDelay: `${delay}s` } : undefined}
        />
      ))}
    </svg>
  );
}
